import {memo, useEffect} from 'react';
import {usePrevious} from '../../../../../../common/shared/hooks/usePrevious';
import {twMerge} from '../../../../../../common/twMerge';
import {Icon} from '../../../../../../design-system/atoms/Icon/Icon';
import {IconType} from '../../../../../../design-system/atoms/Icon/IconType.enum';
import {
  MAX_BASE_VIEWER_WIDTH_PX,
  MOBILE_PULL_COMPONENT_HEIGHT,
  PC_PULL_COMPONENT_HEIGHT,
} from '../constant/talkViewerConstant';
import {useViewerWidth} from '../hook/useViewerWidth.hook';
import {SceneKey} from '../type/KeyType.type';
import {ZIndex} from '../type/ZIndex.enum';
import {disableScroll} from '../util/disableScroll';
import {enableScroll} from '../util/enableScroll';

interface TopPullProps {
  height: number;
  prevSceneId?: SceneKey;
  isMobile: boolean;
  onViewerPulledDown: Function;
  topViewerMenuHeight: number;
  isViewerEndExposed: boolean;
}

export const TalkViewerEventHandleTopPull = memo(
  ({
    height,
    isMobile,
    onViewerPulledDown,
    topViewerMenuHeight,
    isViewerEndExposed,
    prevSceneId,
  }: TopPullProps) => {
    const {viewerWidth} = useViewerWidth();
    const maxHeight =
      (isMobile ? MOBILE_PULL_COMPONENT_HEIGHT : PC_PULL_COMPONENT_HEIGHT) *
      (viewerWidth / MAX_BASE_VIEWER_WIDTH_PX);
    const componentHeight = Math.min(maxHeight, height);
    const prevHeight = usePrevious(componentHeight);
    const isPulled = prevHeight === maxHeight && componentHeight === 0;

    useEffect(() => {
      if ((!prevSceneId && !isViewerEndExposed) || !isMobile) {
        return;
      }
      if (isPulled) {
        onViewerPulledDown();
      }
    }, [
      prevSceneId,
      isPulled,
      isMobile,
      isViewerEndExposed,
      onViewerPulledDown,
    ]);

    if (isMobile) {
      if (height <= 0) {
        enableScroll();
      } else {
        disableScroll();
      }
    }

    useEffect(() => {
      return () => {
        enableScroll();
      };
    }, []);

    if (!prevSceneId && !isViewerEndExposed) {
      return null;
    }
    return (
      <div
        className={twMerge(
          'pointer-events-none absolute top-0 mb-50tvs flex w-full flex-col items-center justify-center overflow-hidden text-static-mono-white',
          !isMobile && 'relative justify-end'
        )}
        style={{
          zIndex: ZIndex.ViewerMenu - 1,
          height: `${isMobile ? maxHeight : componentHeight}px`,
          marginTop: `${topViewerMenuHeight}px`,
        }}
      >
        <Icon
          type={IconType.KatalknovelBefore}
          className="mb-20tvs"
          style={{
            width: `${componentHeight / 2}px`,
            height: `${componentHeight / 2}px`,
          }}
        />
      </div>
    );
  }
);
